import React, { Component } from 'react';
import { pixiApp } from './PixiApp';
import style from './PixiComponent.module.scss';

class PixiComponent extends Component {
  componentDidMount() {
    pixiApp.init(this.pixiContainer);
  }
  render() {
    return (
      <div
        className={`${style.pixi} ${
          this.props.chapterToExhibition ? style.chapterExit : ''
        }`}
        style={{
          width: '100vw',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          pointerEvents: 'none',
        }}
        ref={el => {
          this.pixiContainer = el;
        }}
      />
    );
  }
}

export default PixiComponent;



// WEBPACK FOOTER //
// ./src/components/pixi/PixiComponent.js